<template lang="pug">
  section
    header.header-settings
      .tabs
        .tab.primary-text.active
          span Notifications

    div
      form(@keyup.enter="submit", @submit.prevent="submit")
        .form-field-group
          h6 Notifications
          .form-field(v-for="(value, key) in form.notifications")
            .form-field-toggle
              label.toggle-switch
                .row.center
                  .col
                    input(type="checkbox", v-model="form.notifications[key]")
                    .toggle-switch-slider
                      .toggle-switch-knob
                  .col
                    div
                      span {{notificationsMapper[key].label}}
        div.form-field
          button.button.primary-button(type="submit") Save


</template>

<script>

import { mapState } from 'vuex'

const notificationsMapper = {
  feature_assigned: {
    label: 'Assignment of a feature'
  },
  feature_commented: {
    label: 'Comment on a feature you created'
  },
  feature_status_changed: {
    label: 'Status change on a feature you are following'
  }
}

const defaultNotifications = () => {
  return Object.keys(notificationsMapper).reduce((acc, notification) => {
    acc[notification] = true
    return acc
  }, {})
}

export default {
  name: 'SettingsNotifications',
  beforeCreate () {
    this.$store.dispatch('user/getUser')
      .then(() => {
        this.form = Object.assign({}, this.$store.state.user)
        console.log('hiya', this.form)
      })

  },
  data () {
    return {
      notificationsMapper,
      form: {
        notifications: defaultNotifications()
      }
    }
  },
  computed: {
  },
  methods: {
    submit () {
      this.$store.dispatch('postInvites', this.form).then(() => {
        
      }, errors => {
        this.errors = errors
        console.log(errors)
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>